import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IAddSocialChannelV1Request } from './add-social-channel-v1-request';
import type { IAddSocialChannelV1Response } from './add-social-channel-v1-response';
import { addSocialChannelV1ResponseSchema } from './add-social-channel-v1-response';

export async function addSocialChannelV1Api(
  body: IAddSocialChannelV1Request,
): Promise<IValidatedResponse<IAddSocialChannelV1Response>> {
  return postRequest<IAddSocialChannelV1Response>({
    path: '/sys/social/v1/channels',
    body,
    schema: addSocialChannelV1ResponseSchema,
  });
}
